<label>
	<div class="radiobutton" [ngClass]="{'square': shape === 'square'}">
		<input type="radio" [name]="name" (click)="clicked()" [attr.checked]="checked ? '' : null">
		<span></span>
	</div>
	<div class="label" *ngIf="label">
		{{label}}
	</div>
</label>